var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232 232.5",
    style: {
      enableBackground: "new 0 0 232 232.5"
    },
    xmlSpace: "preserve",
    fill: "rgb(4, 76, 124)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    d: "M232,116.3c0.5,63.3-52.1,116-116.1,116.2C52,232.7,0.5,180.8,0,115.8C-0.5,52.9,51.4,0.6,114.7,0 C179.4-0.6,231.4,51,232,116.3z M209.2,116.5c-0.5-52.4-42.3-94.2-93.9-93.7c-50.9,0.5-93,42.5-92.6,92.3c0.4,53,42,95,93.6,94.6 C167.4,209.3,209.7,166.9,209.2,116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    d: "M174.5,174.1c-39,0-77.8,0-116.7,0c4.1-16.3,25.5-38.9,55.2-40C140.4,133,167.5,150.6,174.5,174.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M91.2,66.7c4.7,4.9,8.5,8.8,12.9,13.3c-4,3.5-8.1,7.1-13.4,11.7c5.1,4.1,9.4,7.6,13.5,11 c-4.7,4.7-8.4,8.5-12.9,13c-3.2-4-6.7-8.3-10.9-13.4c-4.7,5.6-8.3,9.9-11.8,14.1c-5-4.9-8.9-8.7-13.3-13c4.2-3.7,8.2-7.3,13.4-11.9 c-5.2-4.1-9.6-7.6-14.1-11.2c5.1-4.9,8.9-8.5,13.4-12.9c3.2,3.9,6.7,8.3,11.1,13.7C84,75.4,87.6,71.1,91.2,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M141,116.5c-4.7-5.1-8.4-9-12.5-13.4c3.7-3.4,7.7-7,12.4-11.3c-5-4.2-9.3-7.8-13.6-11.4 c4.9-5,8.7-8.9,13.1-13.4c3.7,4.3,7.3,8.4,11.7,13.6c4.3-5.4,7.8-9.8,11.3-14.2c5,5.1,8.9,8.9,13.2,13.4c-4,3.5-8.1,7-13.4,11.7 c5.2,4.2,9.5,7.7,14,11.3c-4.9,4.8-8.8,8.6-13.3,13c-3.6-4.1-7.2-8.2-11.6-13.3C148.2,107.7,144.7,112,141,116.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrustration);
export default __webpack_public_path__ + "static/media/frustration.d59830d70ae86e1fa3732bd70345ecc1.svg";
export { ForwardRef as ReactComponent };